import { RootState } from '../../../Store/index';

export const selectProviderList = (state: RootState) => state.DbInformationReducer.providerList;
export const selectDbModalOpen = (state: RootState) => state.DbInformationReducer.isDbModalOpen;
export const selectDatabases = (state: RootState) => state.DbInformationReducer.databases;